export { createEventTracker } from './createEventTracker';
export type { EventParams } from './internal/types';
